import { apiUserDeleteDepartment, apiUserGetDepartment } from "@/api";
import { useEffect, useState } from "react";

import { Button } from "@mantine/core";
import Card from "@/components/Card";
import { IconPencil } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function DepartmentPage() {
  const { t } = useTranslation();
  const [departmentData, setDepartmentData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const { code, workContent, name, company, leaders, members } =
    departmentData || {};

  const handleProcessPersonData = (data) => {
    if (!data) return;

    return data.data.map((person) => {
      const { name, email, birthday } = person.attributes;
      const image = person.attributes?.image || ""; // Assuming image might be missing
      return { name, email, birthday, image };
    });
  };

  const handleDisplayMembers = (members) => {
    if (!members?.length) {
      return "";
    }

    return members.map((member) => (
      <div className="m-2">
        <Card
          customStyle={{
            baseStyle: { margin: "0rem", width: "200px", height: "120px" },
          }}
          props={member}
        />
      </div>
    ));
  };

  const handleDelete = async () => {
    try {
      let result = await apiUserDeleteDepartment({ id });
      navigate(`/hrMainPage/department`);
    } catch (error) {
      console.error(t("departmentPage.errorDeletingData"), error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiUserGetDepartment({ id });
        setDepartmentData(result?.data);
      } catch (error) {
        console.error(t("departmentPage.errorFetchingData"), error);
      }
    };

    fetchData();
  }, [t]);

  return (
    <div className="flex min-h-screen h-full items-center justify-center p-8">
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="flex justify-end">
            <IconPencil
              className="cursor-pointer"
              size={32}
              onClick={() => navigate(`/hrMainPage/editDepartment/${id}`)}
            />
          </div>
          <div className="flex">
            <div>
              <div
                className="py-3 text-2xl font-bold"
                style={{ color: "#6F6F6F" }}
              >
                {t("departmentPage.departmentName")}
              </div>
              <div>{name}</div>
            </div>
            <div className="pl-3">
              <div
                className="py-3 text-2xl font-bold"
                style={{ color: "#6F6F6F" }}
              >
                {t("departmentPage.departmentCode")}
              </div>
              <div>{code}</div>
            </div>
          </div>

          <div className="py-4">
            <div
              className="py-3 text-2xl font-bold"
              style={{ color: "#6F6F6F" }}
            >
              {t("departmentPage.departmentDescription")}
            </div>
            <div>{workContent}</div>
          </div>

          <div>
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              {t("departmentPage.departmentLeaders")}
            </div>
            <div className="grid grid-cols-1 gap-1 md:grid-cols-3">
              {handleDisplayMembers(leaders)}
            </div>
          </div>
          <div>
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              {t("departmentPage.departmentMembers")}
            </div>
            <div className="grid grid-cols-1 gap-1 md:grid-cols-3">
              {handleDisplayMembers(members)}
            </div>
          </div>
          <div className="flex">
            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => handleDelete()}
            >
              {t("departmentPage.deleteDepartment")}
            </Button>
          </div>
        </>
      </div>
    </div>
  );
}

export default DepartmentPage;
